module.exports = __webpack_public_path__ + "static/media/I2.a654430d.png";